import InventoryAdd from './InventoryAdd'
export default InventoryAdd
